import { Button, IconButton } from '.';

import { DropdownButtonTypeEnum } from '../../enums';
import { DropdownMenuType } from '../../types';
import { FaEllipsisH } from 'react-icons/fa';
import { FunctionComponent } from 'react';

const DropdownMenu: FunctionComponent<DropdownMenuType> = ({
  title,
  operations,
  btnType = DropdownButtonTypeEnum.BUTTON,
  icon = <FaEllipsisH />,
}) => {
  return (
    <div className="dropdown">
      {btnType === DropdownButtonTypeEnum.ICON ? (
        <IconButton
          Icon={icon!}
          title={title}
          onClick={(event) => {
            event.preventDefault();
          }}
          noBorder
          {...{ 'aria-expanded': 'false', 'data-bs-toggle': 'dropdown' }}
        />
      ) : (
        <Button
          title={title}
          className="dropdown-toggle"
          onClick={(event) => {
            event.preventDefault();
          }}
          {...{ 'aria-expanded': 'false', 'data-bs-toggle': 'dropdown' }}
        />
      )}
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        {operations.map((operation) => (
          <li key={`operation-${operation.title}`}>
            <Button
              className="dropdown-item"
              onClick={(event) => {
                event.preventDefault();
                operation.operation();
              }}
              title={operation.title}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropdownMenu;
